"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentsListItem = void 0;
var _hooks = require("../../../../../../../../../hooks");
var _Icon = require("../../../../../../../../../UI/Icon");
var _Avatar = require("../../../../../../../../../UI/Avatar");
var _StudentsListItem = _interopRequireDefault(require("./StudentsListItem.styles"));
var _react = require("react");
var _CetComponentsProvider = require("../../../../../../../../../providers/CetComponentsProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StudentsListItem = props => {
  const styles = (0, _StudentsListItem.default)(props);
  const {
    id,
    fullName,
    isTooltip = false,
    studentsMapper,
    studentsSelectorTempData,
    classesMapper,
    groupsMapper,
    isItemHoverOrSelected = false
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  if (!studentsMapper) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__students-list-item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
      firstName: studentsMapper[id]?.student?.firstName,
      lastName: studentsMapper[id]?.student?.lastName,
      startBy: "LatName",
      avatarUrl: studentsMapper[id]?.student?.avatarUrl,
      withDefaultImage: false,
      size: isMobileView ? 'large' : 'medium',
      background: isItemHoverOrSelected ? themeColors?.primary.shade2 : themeColors?.primary.light
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-AudiencePicker__students-list-item__data'],
      children: [!isTooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-AudiencePicker__students-list-item__data__name'],
        dangerouslySetInnerHTML: {
          __html: fullName
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-AudiencePicker__students-list-item__data__id'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-AudiencePicker__students-list-item__data__icon'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "NameTag",
            width: "20",
            height: "20"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: studentsMapper[id]?.student?.idNumber || `-`
        })]
      }), (studentsSelectorTempData?.isStudentsSearchOpen || isTooltip) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-AudiencePicker__students-list-item__data__groups'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-AudiencePicker__students-list-item__data__icon'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "Users",
            width: "20",
            height: "20"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: isTooltip ? classesMapper && classesMapper[studentsMapper[id]?.classIds[0]]?.group?.name || groupsMapper && groupsMapper[studentsMapper[id]?.groupIds[0]]?.group?.name : [...(studentsMapper[id]?.classIds || []).map(id => classesMapper && classesMapper[id]?.group?.name), ...(studentsMapper[id]?.groupIds || []).map(id => groupsMapper && groupsMapper[id]?.group?.name)].join(', ')
        })]
      })]
    })]
  });
};
exports.StudentsListItem = StudentsListItem;